import {useLogoutMutation} from "../redux/api/authApiSlice";
import {useCallback} from "react";
import {useDispatch} from "react-redux";
import {apiSlice} from "../redux/api/baseApiSlice";
import {baseLanggraphApiSlice} from "../redux/api/langgraph/baseApiSliceLanggraph";
import {defaultRedirectUrl} from "../utils/const";

declare const window: any;

export const useLogout = () => {

    const dispatch = useDispatch();
    const [logoutCall] = useLogoutMutation();
    const logout = useCallback(async(redirectUrl: string = defaultRedirectUrl) => {
        window.Intercom('shutdown')

        dispatch(apiSlice.util.resetApiState());
        dispatch(baseLanggraphApiSlice.util.resetApiState());

        logoutCall().unwrap()
            .then()
            .catch(err => {
                console.error(err)
            })
            .finally(() => {
                window.location.replace(redirectUrl);
            })
    }, [logoutCall, dispatch])

    return {
        logout
    }
};